import React, { useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON_BACKGROUND, SKELETON_FOREGROUND } from '../../../color';
import '../../../components/Loader/SkeletonLoader.css';
const MyLoader = (props) => {
  const rows = 5;
  const columns = 7;
  const coverHeight = 80;
  const coverWidth = 150;
  const padding = 1;
  const speed = 1;

  const coverHeightWithPadding = coverHeight + padding;
  const coverWidthWithPadding = coverWidth + padding;
  const initial = 35;
  const covers = Array(columns * rows).fill(1);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      props.setShowError1(true);
    }, 15000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [props.showError1]);

  if (props.showError1) {
    return <div className="skeletonloader">Oops...Something went wrong</div>;
  }

  return (
    <ContentLoader
      speed={speed}
      width={columns * coverWidthWithPadding}
      height={450}
      backgroundColor={SKELETON_BACKGROUND}
      foregroundColor={SKELETON_FOREGROUND}
      {...props}
    >
      <rect
        x="0"
        y="0"
        rx="0"
        ry="0"
        width={columns * coverWidthWithPadding - padding}
        height="30"
      />

      {covers.map((g, i) => {
        let vy = Math.floor(i / columns) * coverHeightWithPadding + initial;
        let vx =
          (i * coverWidthWithPadding) % (columns * coverWidthWithPadding);
        return (
          <rect
            key={i}
            x={vx}
            y={vy}
            rx="0"
            ry="0"
            width={coverWidth}
            height={coverHeight}
          />
        );
      })}
    </ContentLoader>
  );
};

export default MyLoader;
